const STYLES = {
  "Marks & Spencer": "bg-emerald-900 text-emerald-50",
  Waitrose: "bg-stone-800 text-stone-50",
  "Sainsbury's": "bg-amber-600 text-amber-50",
  Tesco: "bg-blue-700 text-blue-50",
};

export const StoreBadge = ({ store, className = "" }) => (
  <span
    className={`inline-block text-[10px] font-mono font-medium uppercase tracking-wider px-2.5 py-1 rounded-full ${STYLES[store] || "bg-slate-700 text-white"} ${className}`}
    data-testid="store-badge"
  >
    From {store}
  </span>
);
